import React from "react";
import { observer } from "mobx-react";
import {
  Switch as SwitchContext,
  Redirect,
  withRouter,
  RouteComponentProps,
} from "react-router-dom";

import AuthStore from "stores/AuthStore";

import Container from "components/Layout/Container";
import Header from "components/Layout/Header";
import PublishButton from "components/PublishButton";

import { PrivateRoute } from "navigation/Switch";

import ROUTES from "navigation/routes";
import Coach from "./Coach";
import CoachDetails from "./Coach/CoachDetails";

type Props = RouteComponentProps & {};

@observer
class CoachResources extends React.Component<Props> {
  render() {
    return (
      <Container header={<Header controls={<PublishButton />} />}>
        <SwitchContext>
          <PrivateRoute
            path={ROUTES.CONTENT_PERSONAL_COACH}
            component={Coach}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_PERSONAL_COACH}
            exact
          />
          <PrivateRoute
            path={ROUTES.CONTENT_PERSONAL_COACH_DETAIL}
            component={CoachDetails}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_PERSONAL_COACH_DETAIL}
            exact
          />

          <Redirect to={ROUTES.CONTENT_PERSONAL_COACH} />
        </SwitchContext>
      </Container>
    );
  }
}

export default withRouter(CoachResources);
